export default __webpack_public_path__ + "static/media/eyes2.36fcb127.png";